import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import { Subsidiary } from 'features/Welcome/HotelSwitcher/Subsidiary'
import moment from 'moment'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import pmsApi from 'services/api/pms'

import styles from './MoveDialog.module.scss'

function MoveLogsByEmailDialog({ onClose, emailSummary }) {
  const subsidiaryList = useSelector(s => s.login.subsidiaryList)
  const currentHotel = useSelector(s => s.hotelDetails)
  const [selectedHotel, setSelectedHotel] = useState()
  const [searchParam, setSearchParam] = useState('')

  const selectableHotels = subsidiaryList.filter(
    hotel =>
      hotel.subsidiaryId !== currentHotel.subsidiaryId && hotel.pms === currentHotel.pms
  )
  const filteredHotels = selectableHotels.filter(h =>
    (h.subsidiaryName + ' #' + h.displayId).match(new RegExp(searchParam, 'i'))
  )

  const onConfirm = async () => {
    try {
      await pmsApi.migrateEmail({
        email: emailSummary.email,
        targetSubsidiaryId: selectedHotel.subsidiaryId
      })
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <ConfirmationDialog
      hasDangerousAction
      hasCloseButton
      hasConfirmButton={!!selectedHotel}
      negativeMessage={selectedHotel ? 'Cancel' : undefined}
      positiveMessage="Confirm and start the process"
      contentAbove={
        <div className={styles.contentAboveContainer}>
          <i className={styles.warningIcon} />
          <p className={styles.warningText}>
            Pay attention! This process may have severe consequences and cannot be
            reversed.
          </p>
        </div>
      }
      title={selectedHotel ? 'Are you sure?' : `Moving ${emailSummary.email}`}
      onClose={onClose}
      onReject={selectedHotel ? () => setSelectedHotel(undefined) : onClose}
      onConfirm={onConfirm}
      contentPadding="0"
    >
      <div className={styles.row}>
        <div className={styles.statusCol}>
          <p className={styles.title}>Last Record</p>
          <p className={styles.subTitle}>
            {moment(emailSummary.lastUploadOn).format('MMM DD, hh:mm A')}
          </p>
        </div>

        <div className={styles.statusCol}>
          <p className={styles.title}>Records</p>
          <p className={styles.subTitle}>6</p>
        </div>

        <div className={styles.buttonCol}>See all records</div>
      </div>

      {selectedHotel ? (
        <p className={styles.confirmationText}>
          I confirm {emailSummary.email} and all related records to deleted from #
          {currentHotel.displayId} {currentHotel.name} and to be re-uploaded to #
          {selectedHotel.displayId} {selectedHotel.merchantName}{' '}
          {selectedHotel.subsidiaryName}.
        </p>
      ) : (
        <>
          <p className={styles.selectHotelText}>Select a hotel to move</p>

          <div className={styles.hotelSelectorWrapper}>
            <div className="hotel-selector">
              <div className="hotel-selector__filter" style={{ display: 'flex' }}>
                <input
                  type="search"
                  placeholder="Search..."
                  onChange={e => setSearchParam(e.target.value)}
                  value={searchParam}
                />
              </div>

              <ul>
                {filteredHotels.map(hotel => (
                  <Subsidiary
                    key={hotel.subsidiaryId}
                    hotel={hotel}
                    handleSelect={setSelectedHotel}
                  />
                ))}
              </ul>
            </div>
          </div>
        </>
      )}
    </ConfirmationDialog>
  )
}

export default MoveLogsByEmailDialog
